
import { removeGameAccount, userAccountsReducer, accountActions } from './userAccountsStore';
import { setUser, setAuthState, userAuthStateReducer } from './userAuthStore';
import { loadPersonalBonusCodes, loadUsedBonusCodes, userBonusCodesReducer } from './userBonusCodesStore';
import { characterActions, userCharactersReducer } from './userCharactersStore';
import { clearUserData, loadBalance, userDataReducer, setBalance, dataActions } from './userDataStore';
import { inventoryActions, userInventoryReducer } from './userInventoryStore';
import { loadAuthLogs, loadDonateLogs, userLogsReducer } from './userLogsStore';
import { loadMarket, userMarketReducer } from './userMarketStore';
import { userNotificationsReducer, notificationActions } from './userNotificationsStore';
import { projectActions, userProjectReducer } from './userProjectStore';
import { loadNews, userShortNewsReducer } from './userShortnewsStore';
import {
    loadTaskMessages,
    addTaskMessage,
    userTaskMessagesReducer,
    editTaskMessage,
    deleteTaskMessage
} from './userTaskMessagesStore';
import { loadTask, loadTasks, createTask, userTaskReducer } from './userTasksStore';

import { combineReducers } from '@reduxjs/toolkit';
import { UserStore } from '@interfaces/store';
import { dailyActions, dailyReducer } from './userDailyStore';
import { donateBonusActions, donateBonusReducer } from './userDonateBonus';
import { itemsReducer } from './userItemsStore';
import { goalActions, goalsReducer } from './userGoalStore';
import { refActions, refReducer } from './userRefStore';

export const userReducer = combineReducers({
    accounts: userAccountsReducer,
    bonusCodes: userBonusCodesReducer,
    user: userDataReducer,
    characters: userCharactersReducer,
    inventory: userInventoryReducer,
    logs: userLogsReducer,
    notifications: userNotificationsReducer,
    project: userProjectReducer,
    market: userMarketReducer,
    shortNews: userShortNewsReducer,
    taskList: userTaskReducer,
    taskMessages: userTaskMessagesReducer,
    authState: userAuthStateReducer,
    daily: dailyReducer,
    donateBonuses: donateBonusReducer,
    items: itemsReducer,
    goals: goalsReducer,
    refs: refReducer
});

export const userActions = {
    data: dataActions,
    project: projectActions,
    accounts: accountActions,
    characters: characterActions,
    inventory: inventoryActions,
    notifications: notificationActions,
    donateBonus: donateBonusActions,
    
    clearUserData,
    loadBalance,
    setBalance,
    removeGameAccount,
    loadPersonalBonusCodes,
    loadUsedBonusCodes,
    loadAuthLogs,
    loadDonateLogs,

    loadMarket,
    loadNews,
    loadTask,
    loadTasks,
    loadTaskMessages,
    editTaskMessage,
    deleteTaskMessage,

    setUser,
    setAuthState,
    createTask,
    addTaskMessage,

    daily: dailyActions,
    goals: goalActions,
    refs: refActions
}